module.exports = __webpack_public_path__ + "img/fact-check-image.0829ef91.jpg";